module.exports = __webpack_public_path__ + "static/media/search.c2078232.svg";